import React, { PropsWithChildren } from 'react';
import { IFieldSetProps } from '../types/IFieldSetProps';
import FormTooltip from './FormTooltip';

function FieldSet({
    children,
    description,
    descriptionSubtext,
    tooltip,
    fieldSetName,
}: PropsWithChildren<IFieldSetProps>) {

    const tooltipJsx = tooltip && <FormTooltip tooltip={tooltip} />;

    return (
        <div className="container-fluid fieldset">
            <div className="row applicant-content">
                {
                    fieldSetName &&
                    <div className="col-12 fieldset-title">
                        <h5>
                            <span>{fieldSetName}</span>
                        </h5>
                    </div>
                }
                {
                    description && !tooltipJsx &&
                    <div className="fieldset-description">
                        <div
                            dangerouslySetInnerHTML={{ __html: description }}
                        />

                        {descriptionSubtext && (
                            <div className="fieldset-description-subtext">
                                {descriptionSubtext}
                            </div>
                        )}
                    </div>
                }
                {
                    description && tooltipJsx &&
                    <div className="col-12 d-flex align-items-start justify-content-between">
                        <div
                            className="fieldset-description"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        {tooltipJsx}
                    </div>
                }
                <div className="col-12">
                    <div className="row">{children}</div>
                </div>
            </div>
        </div>
    );
}

export default FieldSet;
